@if (condition) {
  <div class="processing-status-editor" [formGroup]="detailsFormGroup">
    <div class="row">
      @if (processingStatus != null && processingStatus.length > 0) {
        <mat-form-field class="flex-grow" appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.processing-status-editor.processing-status"></sc-dictionary-label>
          </mat-label>
          <mat-select formControlName="processingStatus" name="processingStatus">
            @for (o of processingStatus; track o) {
              <mat-option [value]="o.key">
                <sc-dictionary-label [dictionaryKey]="o.dictionaryKey"></sc-dictionary-label>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  </div>
}
